import { AppUtil } from 'kuaidong-lib'
import { IPayOnBehalfOfInfo, IPayOnBehalfOfOrder } from 'kuaidong-model'

export function find(_id: string): Promise<IPayOnBehalfOfInfo> {
  return AppUtil.httpGET(`${process.env.VUE_APP_PAY_API}/payment/share_pay/info`, { share_pay_id: _id })
}

export function order(_id: string): Promise<IPayOnBehalfOfOrder> {
  return AppUtil.httpPOST(`${process.env.VUE_APP_PAY_API}/payment/share_pay/submit_order`, { share_pay_id: _id })
}

export function create(_sku: string): Promise<IPayOnBehalfOfInfo> {
  return AppUtil.httpPOST(`${process.env.VUE_APP_PAY_API}/payment/share_pay/gen`, { sku_code: _sku })
}
